import gal1 from "./Images/Illustration/redcar.jpg";
import gal2 from "./Images/Illustration/thar.jpg";
import gal3 from "./Images/Illustration/galimg.jpg";
import gal4 from "./Images/Illustration/gal2.jpg";


const Gallary = () => {
    return (
        <section class='container-fluid'>
            <div class='row'>
                <div class='col-12 back2 text-white align'>
                    <h3>Gallary</h3>

                    <div className="d-flex justify-content-center pt-3"> <nav aria-label="breadcrumb ">
                        <ol class="breadcrumb ">
                            <li class="breadcrumb-item"><a href="Home">Home</a></li>
                            <li class="breadcrumb-item active" aria-current="Gallary">Gallary</li>
                        </ol>
                    </nav></div>
                </div>
            </div>
            <div class='col-12'>
                <div className="row py-5 justify-content-evenly">

                    <div className="col-12 col-md-4 gal">
                        <img src={gal1} className="img-fluid" alt="Image Not Fount" /></div>
                    <div className="col-12 col-md-4 gal">
                        <a><img src={gal2} className="img-fluid" alt="Image Not Fount" /></a></div>
                    <div className="col-12 col-md-4 gal">
                        <a><img src={gal3} className="img-fluid" alt="Image Not Fount" /></a></div>

                    <div className="row py-5">
                        <div className="col-12 col-md-4 gal">
                            <a><img src={gal2} className="img-fluid" alt="Image Not Found" /></a></div>
                        <div className="col-12 col-md-4 gal">
                            <a><img src={gal4} className="img-fluid" alt="Image Not Found" /></a></div>
                        <div className="col-12 col-md-4 gal">
                            <a><img src={gal1} className="img-fluid" alt="Image Not Found" /></a></div>
                    </div>
                    <a className="btn col-1 p-0 text-center" href="#">More Pictures</a>
                </div >
                
            </div >
           
        </section >
    )
};

export default Gallary;
